import { render, staticRenderFns } from "./ErrorGeneral.vue?vue&type=template&id=7eeeeda0"
import script from "./ErrorGeneral.vue?vue&type=script&lang=ts"
export * from "./ErrorGeneral.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports